module.exports = __webpack_public_path__ + "media/country_flags/ai-20d22913.png";